// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/unserviceable-equipment-mel.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/unserviceable-equipment-mel/markings-and-placards-before-takeoff.js';
import g1 from '../lessons/air-law/unserviceable-equipment-mel/pic-safety-override-and-flight-permit.js';
import g2 from '../lessons/air-law/unserviceable-equipment-mel/unserviceable-equipment-mel.js';

mount([g0, g1, g2]);
